import { Preferences } from './Preferences.component';

export default Preferences;
